module.exports = __webpack_public_path__ + "245fe2009e1cd2961f71fe87619c18e9.svg";